import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import api from "@/lib/api";
import { Play } from "lucide-react";

export default function Live() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/content", { params: { type: "live" } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <Layout>
      <div className="pt-28 px-4 md:px-12 pb-12">
        <div className="flex items-center gap-3 fade-up">
          <span className="flex items-center gap-2 text-[var(--nik-live)] font-bold tracking-wider text-sm">
            <span className="w-2.5 h-2.5 rounded-full bg-[var(--nik-live)] live-dot" /> LIVE NOW
          </span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white mt-2">Live Entertainment</h1>
        <p className="text-slate-400 mt-2">Concerts, sports and comedy — streaming live, only on KalamPrime.</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(items || []).map((item) => (
            <div
              key={item.id}
              data-testid="content-card-item"
              onClick={() => navigate(`/watch/${item.id}`)}
              className="relative rounded-xl overflow-hidden cursor-pointer group border border-white/10"
            >
              <img src={item.backdrop} alt={item.title} className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14] via-transparent to-transparent" />
              <span className="absolute top-3 left-3 flex items-center gap-1.5 text-xs font-bold px-2 py-1 rounded bg-[var(--nik-live)] text-white">
                <span className="w-1.5 h-1.5 rounded-full bg-white live-dot" /> LIVE
              </span>
              <div className="absolute bottom-0 p-4">
                <h3 className="font-display text-lg font-bold text-white">{item.title}</h3>
                <p className="text-xs text-slate-300 mt-1 line-clamp-2">{item.description}</p>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                  <Play size={24} className="text-black ml-1" fill="currentColor" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
